/**
 * @fileoverview POST handler for the "/app_settings/compute_custom_attribute_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppSettingsComputeCustomAttributeUsageCacheKeys } from "./constants";
import type {
  PostAppSettingsComputeCustomAttributeUsageProps,
  PostAppSettingsComputeCustomAttributeUsageResult,
} from "./types";

export const postAppSettingsComputeCustomAttributeUsage = reactQueryMutationAdapter(
  postAppSettingsComputeCustomAttributeUsageCacheKeys,
  ({
    appGroupId,
  }: PostAppSettingsComputeCustomAttributeUsageProps): Promise<PostAppSettingsComputeCustomAttributeUsageResult> => {
    return fetch("/app_settings/compute_custom_attribute_usage", "POST", { app_group_id: appGroupId });
  }
);
